
export default
  name: 'results-table'
  data: ->
    heats: general.heats || []
    races: general.races || []
    filterCategory: null
    filter: null
    fields: [
      {key: 'rank_abs', label: i18n.t('ranks.abs'), class: 'text-center'},
      {key: 'rank_gender', label: i18n.t('ranks.gender'), class: 'text-center'},
      {key: 'rank_category', label: i18n.t('ranks.category'), class: 'text-center'},
      {key: 'bib', label: i18n.t('bib'), class: 'text-center'},
      {key: 'name', label: i18n.t('name'), isRowHeader: true},
      {key: 'team', label: i18n.t('team')},
      {key: 'category', label: i18n.t('category')},
      {key: 'result', label: i18n.t('result'), class: 'text-center font-weight-bold'}
    ]
    raceCategories: general.race_categories || []
  methods:
    myFilter: (item, filter) ->
      item.category == filter
